import React from 'react';
import PropTypes from 'prop-types';
import {
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
  TooltipContent,
} from '@cargomatic/ui';
import { getClassName } from '../../utils/ui/classes';
import Badge from 'components/v2/Badge';
import { Info } from 'lucide-react';

const DescriptionListItem = ({
  label,
  labelClassName,
  children,
  className,
  darkMode,
  info,
  position,
  dataTestId,
  badgeInfo,
  badgeColor,
}) => (
  <div
    className={getClassName(className)}
    data-testid={dataTestId || 'description-list-item'}
  >
    <dt
      data-testid="dt-138eb68d"
      className={getClassName('my-0 text-sm font-medium', labelClassName, {
        'text-gray-500': !darkMode,
        'text-gray-200': darkMode,
      })}
    >
      <div
        className="flex items-center"
        data-testid="description-list-item-header"
      >
        {label}
        {badgeInfo && (
          <Badge dataTestId="Badge-f03af3d9" color={badgeColor || 'gray'}>
            {badgeInfo}
          </Badge>
        )}
        {info && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="ml-1" data-testid="description-list-item-info">
                  <Info size={14} />
                </div>
              </TooltipTrigger>
              <TooltipContent side={position || 'top'} className="max-w-xs">
                <p>{info}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
    </dt>
    <dd
      data-testid="dd-33c9987e"
      className={getClassName('break-words mt-1 text-sm', {
        'text-gray-900': !darkMode,
        'text-white': darkMode,
      })}
    >
      {children}
    </dd>
  </div>
);

DescriptionListItem.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  darkMode: PropTypes.bool,
};

DescriptionListItem.defaultProps = {
  darkMode: false,
};

export default DescriptionListItem;
